import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { JackpotOptInPromptModal } from '@/components/JackpotOptInPromptModal';
import { useJackpotOptInPrompt } from '@/contexts/JackpotOptInPromptContext';
import { useRecentlyPlayed } from '@/contexts/RecentlyPlayedContext';

export const GlobalJackpotOptInPromptModal = () => {
  const navigate = useNavigate();
  const { addRecentlyPlayed } = useRecentlyPlayed();
  const {
    isPromptOpen,
    pendingNavigation,
    onOptInAndPlay,
    onPlayWithoutOptIn,
    closePrompt,
    setNavigationCallback,
  } = useJackpotOptInPrompt();

  const handleNavigate = useCallback((gameId: string) => {
    if (pendingNavigation) {
      addRecentlyPlayed({
        id: pendingNavigation.gameId,
        title: pendingNavigation.gameTitle,
        image: pendingNavigation.gameImage,
        provider: pendingNavigation.gameProvider,
      });
    }
    navigate(`/play/${gameId}`);
  }, [navigate, addRecentlyPlayed, pendingNavigation]);

  useEffect(() => {
    setNavigationCallback(handleNavigate);
  }, [setNavigationCallback, handleNavigate]);

  return (
    <JackpotOptInPromptModal
      isOpen={isPromptOpen}
      onOptInAndPlay={onOptInAndPlay}
      onPlayWithoutOptIn={onPlayWithoutOptIn}
      onClose={closePrompt}
    />
  );
};
